{
    "DAYS": "días",
    "HOURS": "horas",
    "MINUTES": "min",
    "SECONDS": "seg",
    "STARTING_SOON": "En instantes...",
    "EVENT_NOT_STARTED": "Este evento aún no ha comenzado...",
    "DEFAULT_ERROR": "Error de reproducción",
    "DEFAULT_ERROR_DESCRIPTION": "No se puede reproducir el video. Por favor, inténtelo de nuevo más tarde.",
    "API_ERROR": "Error al recuperar información del video",
    "API_ERROR_DESCRIPTION": "Error al obtener detalles del video. Verifique su videoId y conexión a internet e inténtelo de nuevo.",
    "ERROR_CODE_NOT_AUTHENTICATED": "Autorización",
    "ERROR_CODE_NOT_AUTHENTICATED_DESCRIPTION": "No tienes permiso para reproducir este video.",
    "ERROR_CODE_GEO_BLOCKED": "Restricción geográfica",
    "ERROR_CODE_GEO_BLOCKED_DESCRIPTION": "Lo siento, este video no está disponible en tu región debido a restricciones geográficas.",
    "ERROR_CODE_NOT_ENTITLED": "No autorizado",
    "ERROR_CODE_NOT_ENTITLED_DESCRIPTION": "Lo siento, no estás autorizado para reproducir este video.",
    "ERROR_CODE_VPN_BLOCKED": "VPN BLOQUEADO",
    "ERROR_CODE_VPN_BLOCKED_DESCRIPTION": "Este video no está disponible debido al uso de una VPN.",
    "ERROR_CODE_IP_CHANGED": "Cambio de red",
    "ERROR_CODE_IP_CHANGED_DESCRIPTION": "Ha cambiado de red inesperadamente. Por favor, inténtelo de nuevo.",
    "ERROR_CODE_VPN_DETECTED": "VPN detectada",
    "ERROR_CODE_VPN_DETECTED_DESCRIPTION": "Hemos detectado una VPN. Desactívela e inténtelo de nuevo.",
    "ERROR_CODE_ANONYMOUS_PROXY": "Proxy anónimo detectado",
    "ERROR_CODE_ANONYMOUS_PROXY_DESCRIPTION": "Hemos detectado un proxy anónimo o un servidor. Desactívelo e inténtelo de nuevo."
}
